import { AbstractComponent } from '@/utils/sections/abstract-component';
import { register } from '@/utils/sections/registration';

export class GalleryGrid extends AbstractComponent {
  init() {
    // const block = this.el;
    // const gallery = this.el.querySelector('[data-items]');
    // const galleryItems = this.el.querySelectorAll('[data-item]');
    // const blockTopOffset = block.getBoundingClientRect().top
    // const blockWidth = block.offsetWidth;
    // const blockHeight = block.offsetHeight;
    // const galleryWidth = gallery.offsetWidth;
    // const galleryHeight = gallery.offsetHeight;
    //
    // let targetX = blockWidth / 2;
    // let targetY = blockHeight / 2;
    // let currentX = targetX;
    // let currentY = targetY;
    // let adjustedX = false
    // let adjustedY = false
    //
    //
    // const lerp = (start, end, factor) => {
    //   return start + (end - start) * factor;
    // }
    //
    // const updateGalleryPosition = () => {
    //   currentX = lerp(currentX, targetX, 0.05);
    //   currentY = lerp(currentY, targetY, 0.05);
    //
    //   gallery.style.transform = `translate(${currentX}px, ${currentY}px)`;
    //
    //   requestAnimationFrame(updateGalleryPosition);
    // }
    //
    // block.addEventListener('mousemove', (event) => {
    //   const mouseX = event.clientX;
    //   const mouseY = event.clientY - blockTopOffset;
    //   let percentX = mouseX / blockWidth;
    //   let percentY = mouseY / blockHeight;
    //
    //   if (adjustedX !== false) {
    //     percentX = adjustedX;
    //   }
    //
    //   if (adjustedY !== false) {
    //     percentY = adjustedY;
    //   }
    //
    //   targetX = (blockWidth - galleryWidth) * percentX;
    //   targetY = (blockHeight - galleryHeight) * percentY;
    // });

    // galleryItems.forEach((item) => {
    //   item.addEventListener('mouseenter', () => {
    //     console.log('item.offsetLeft', item.offsetLeft);
    //
    //       adjustedX = item.offsetLeft < 100 ? 0 : false;
    //
    //   });
    //
    //   item.addEventListener('mouseleave', () => {
    //     if (item.offsetLeft < 100) {
    //       adjustedX = false;
    //     }
    //   });
    // });

    // requestAnimationFrame(updateGalleryPosition);

    // block.addEventListener('mousemove', (event) => {
    //
    //   const mouseX = event.pageX;
    //   const mouseY = event.pageY - blockTopOffset;
    //
    //   const percentX = mouseX / blockWidth;
    //   const percentY = mouseY / blockHeight;
    //
    //   const galleryX = (blockWidth - galleryWidth) * percentX;
    //   const galleryY = (blockHeight - galleryHeight) * percentY;
    //
    //   gallery.style.transform = `translate(${galleryX}px, ${galleryY}px)`;
    // });
  }
}

register('gallery-grid', GalleryGrid);
